export { default as PhotoUploader } from './PhotoUploader';



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/index.ts